import { AfterViewInit, Component, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ApiViewerService } from "../../viewer-components/services/internal-services/api-viewer.service";
import { MatSelect } from "@angular/material/select";
import { ViewerConstants } from "../../shared/model/viewer-constants";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../shared/model/google-analytics-constants";
import { Subscription } from "rxjs";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { ReportService } from "../../viewer-components/services/internal-services/report.service";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";

@Component({
  selector: "lib-property-information-dialog",
  templateUrl: "./property-information-dialog.component.html",
  styleUrls: ["./property-information-dialog.component.scss"],
  providers: [MatDialogConfig, ApiViewerService],
  standalone: false,
})
export class PropertyInformationDialogComponent implements AfterViewInit {
  productSelected;

  propertyDialog;

  formSubmitted = false;

  availableAOIs = [];

  loading = false;

  progress = 0;

  featuresCount = 0;

  viewerService: BaseViewerService;

  reportService: ReportService;

  googleAnalyticsService: GoogleAnalyticsService;

  subscriptions: Subscription[] = [];

  parameterTypes = ViewerConstants.PROPERTY_FEATURES_TYPES;

  @ViewChild("eventSelector") eventSelector: MatSelect;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matDialog: MatDialog,
  ) {}

  ngAfterViewInit(): void {
    this.propertyDialog = this.matDialog.getDialogById("property-information-dialog");
    this.viewerService = this.data.viewerService;
    this.reportService = this.data.reportService;
    this.googleAnalyticsService = this.data.googleAnalyticsService;
    //this.retrieveDamageAssessment(this.data);
  }

  submit(): void {
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.MY_DATA_REVIEW_PIF_X_PROPERTY_INFORMATION,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );
    this.formSubmitted = true;
  }

  closeDialog() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.propertyDialog.close();
  }

  cancel() {
    this.formSubmitted = false;
  }

  getSummaryTitle() {
    return this.formSubmitted ? "Ready to start processing!" : "Retrieve property information";
  }

  getSummaryDescription() {
    return this.formSubmitted
      ? "Are you sure you want to move forward with this assessment?"
      : "Retrieve property information for properties in the list. The most recent information for each location will be used. " +
          "A file with the appended information will automatically download for you to share with your organization.";
  }

  getPropertyInformation(productSelected) {
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.MY_DATA_START_PROCESSING_PIF_X_PROPERTY_INFORMATION,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );
    this.reportService.getPropertyInformation(
      productSelected,
      this.data.source.features.features,
      this.removeFileExtension(this.data.name),
    );
    this.propertyDialog.close();
  }

  removeFileExtension(fileName) {
    const lastDotIndex = fileName.lastIndexOf(".");
    if (lastDotIndex !== -1 && lastDotIndex !== 0) {
      const nameWithoutExtension = fileName.substring(0, lastDotIndex);
      return nameWithoutExtension;
    }
    return fileName;
  }
}
